import { render, staticRenderFns } from "./SuppliesSelect.vue?vue&type=template&id=05c943a8"
import script from "./SuppliesSelect.vue?vue&type=script&lang=js"
export * from "./SuppliesSelect.vue?vue&type=script&lang=js"
import style0 from "./SuppliesSelect.vue?vue&type=style&index=0&id=05c943a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports